import { useCurrentRole } from '@user';
import { RolePermissions } from '@permissions';
import { isAvailableByRole } from '../utils';

export const useIsAvailableByRole = (options: RolePermissions): boolean => {
  const currentRole = useCurrentRole();
  return isAvailableByRole(currentRole, options);
};
